
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.902 12.279c-.452-1.967-.974-4.28-.974-4.28s0-.382.381-.611c0-.535-.076-1.298.077-1.527.229-.305.152-1.221 1.068-1.221s.84.916 1.069 1.221c.153.305.076 1.069.076 1.527.382.229.382.61.382.61l-1.005 4.278 1.768.379v.763H7.712c-.153.68-.258 1.162-.258 1.222-.023-.071-.091-.356-.294-1.234l-.258-1.127zm.258 1.127c.02.086-.019-.082 0 0l-2.072.012v-.763l1.814-.376.258 1.127z"}}),_c('path',{attrs:{"d":"M7.727 6.938l.476.595 2.62 3.69-.357.18s-.06 0-.12-.06-2.321-3.274-2.321-3.274l-.06-.595-.357-.476h-.119c-.179 0-.357-.12-.357-.298l-.714.12-4.524.415-.06-.416s0-.06.12-.06 3.988-.416 3.988-.416l.535.238.596-.06c.059-.178.178-.297.356-.297h.12l.237-.715 1.906-4.107.357.179s.059.06 0 .119c-.06.12-1.667 3.63-1.667 3.63l-.476.358-.298.536c.06.059.12.178.12.297.118.238.058.357 0 .417z"}})])
          )
        }
      }
    